export function metricsHelper(value) {
    return value?.toLowerCase().split(' ').join('-');
}
//# sourceMappingURL=metricsHelper.js.map